import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UtilitiesService } from 'src/app/core/services/utilities.service';
import { environment } from 'src/environments/environment';
import { API_URL } from '../enums/api-enums';
import { RequestOption } from '../model/common.model';
import { GetAllResponse, SingleResponse } from './../model/restful-api.model';
import { ScorecardFilterModel, ScorecardSettingModel } from './../model/scorecard-setting.model';

@Injectable({
  providedIn: 'root'
})
export class ScorecardSettingService {

  baseUrl = environment.portalURL;
  constructor(
    private util: UtilitiesService
  ) { }

  getData(requestOption: RequestOption, model: ScorecardFilterModel): Observable<SingleResponse<any>> {
    let params = new HttpParams();
    if (model) {
      if (model.search) {
        params = params.append('searchKey', model.search);
      }
      if (model.years) {
        params = params.append('years', model.years.join(','));
      }
    }
    params = params.append('page', requestOption.pagingOptions.number.toString());
    params = params.append('size', requestOption.pagingOptions.size.toString());
    if (requestOption.pagingOptions.sort.sortBy && requestOption.pagingOptions.sort.sortOrder) {
      params = params.append('sortBy', requestOption.pagingOptions.sort.sortBy);
      params = params.append('sortDirection', requestOption.pagingOptions.sort.sortOrder);
    }
    return this.util.req.httpGet<SingleResponse<any>>(this.baseUrl + API_URL.SCORECARD_SETTING + '/filter?' + params);
  }

  create(payload: ScorecardSettingModel): Observable<SingleResponse<any>> {
    return this.util.req.httpPost(this.baseUrl + API_URL.SCORECARD_SETTING, payload)
  }

  update(model, parent, year, gsl) {
    let params = new HttpParams();
    params = params.append('parent', parent);
    params = params.append('year', year);
    if (gsl) {
      params = params.append('gsl', gsl);
    }
    return this.util.req.httpPut(this.baseUrl + API_URL.SCORECARD_SETTING + '?' + params, model);
  }

  getParentCompany() {
    return this.util.req.httpGet<SingleResponse<any>>(this.baseUrl + API_URL.SCORECARD_SETTING + '/filter/parents');
  }

  getYears(): Observable<GetAllResponse<any>> {
    return this.util.req.httpGet<GetAllResponse<any>>(this.baseUrl + API_URL.SCORECARD_SETTING + '/filter/years');
  }

  getGSLNumbers(): Observable<GetAllResponse<any>> {
    return this.util.req.httpGet<GetAllResponse<any>>(this.baseUrl + API_URL.SCORECARD_SETTING + '/filter/gsl');
  }

  getScorecardSetting(parent, year, gsl): Observable<SingleResponse<any>> {
    let params = new HttpParams();
    params = params.append('parent', parent);
    params = params.append('year', year);
    if (gsl) {
      params = params.append('gsl', gsl);
    }
    return this.util.req.httpGet<SingleResponse<any>>(this.baseUrl + API_URL.SCORECARD_SETTING +
      '?' + params);
  }

  deleteSetting(parent, year, gsl): Observable<SingleResponse<any>> {
    let params = new HttpParams();
    params = params.append('parent', parent);
    params = params.append('year', year);
    if (gsl) {
      params = params.append('gsl', gsl);
    }
    return this.util.req.httpDelete<SingleResponse<any>>(this.baseUrl + API_URL.SCORECARD_SETTING + '?' + params);
  }

  addStayInformed(model) {
    return this.util.req.httpPost(this.baseUrl + API_URL.SCORECARD_SETTING, model);
  }

  getDefaultSetting(): Observable<SingleResponse<any>> {
    return this.util.req.httpGet<SingleResponse<any>>(this.baseUrl + API_URL.SCORECARD_SETTING + '/initial');
  }

}
